import { ACTIVATE_SUBSCRIPTIONS } from '../components/messages/message-types';
import { showMessage } from '../../common/messages/framework/store/message-actions';
import {
  getApplicationConfig,
  hasMembersGroupsByType,
} from '@wix/communities-forum-client-commons';
import { PAID_PLANS_APP_ID } from '../constants/applications';

import { GROUP_TYPE_PAID_PLAN } from '../constants/manage-category-members';
import { isOwner } from '../../common/store/current-user/current-user-selectors';
import { fetchSiteId } from './fetch-site-id';

export const showActivateSubscriptionMessage = () => (dispatch) =>
  dispatch(showMessage(ACTIVATE_SUBSCRIPTIONS));

export const showActivateSubscriptionMessageIfNeeded = () => (dispatch, getState) => {
  const state = getState();
  const isPaidPlansInstalled = getApplicationConfig(state, PAID_PLANS_APP_ID).isInstalled;
  const hasPaidPlanGroups = hasMembersGroupsByType(state, GROUP_TYPE_PAID_PLAN);

  if (isOwner(state) && !isPaidPlansInstalled && hasPaidPlanGroups) {
    dispatch(fetchSiteId()).then(() => dispatch(showActivateSubscriptionMessage()));
  }
};
